import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck } = FiIcons;

function CluesList({ words, activeWord, completedWords, onWordSelect }) {
  const horizontalWords = words.filter(word => word.direction === 'horizontal');
  const verticalWords = words.filter(word => word.direction === 'vertical');

  const isCompleted = (word) => {
    return completedWords.some(completed => completed.id === word.id);
  };

  const isActive = (word) => {
    return activeWord && activeWord.id === word.id;
  };

  const ClueSection = ({ title, words, direction }) => (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-primary mb-3 flex items-center gap-2 font-rubik">
        {title}
        <span className="text-sm text-primary">
          ({words.filter(isCompleted).length}/{words.length})
        </span>
      </h3>
      <div className="space-y-2">
        {words.map((word, index) => (
          <motion.button
            key={word.id}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => onWordSelect(word)}
            className={`
              clue-item w-full text-left p-3 rounded-lg border transition-all
              ${isActive(word) ? 'active border-primary' : 'border-gray-200'}
              ${isCompleted(word) ? 'completed' : ''}
              hover:shadow-sm
            `}
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="font-semibold text-primary font-rubik">
                  {word.number}
                </span>
                {isCompleted(word) && (
                  <SafeIcon 
                    icon={FiCheck} 
                    className="text-primary text-sm" 
                  />
                )}
              </div>
              <div className="flex-1">
                <p className="text-primary font-rubik">{word.clue}</p>
                <p className="text-xs text-primary mt-1 font-rubik">
                  {word.answer.length} Buchstaben
                </p>
              </div>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
    >
      <h2 className="text-xl font-semibold text-primary mb-4 font-rubik">Hinweise</h2>
      
      <div className="clue-list">
        <ClueSection 
          title="Waagerecht" 
          words={horizontalWords} 
          direction="horizontal" 
        />
        <ClueSection 
          title="Senkrecht" 
          words={verticalWords} 
          direction="vertical" 
        />
      </div>

      <div className="mt-6 p-3 bg-gray-50 rounded-lg">
        <div className="text-sm text-primary">
          <p className="font-medium mb-1 font-rubik">Anleitung:</p>
          <ul className="space-y-1 text-xs font-rubik">
            <li>• Klicke auf einen Hinweis, um das Wort zu markieren</li>
            <li>• Tippe die Buchstaben direkt ins Gitter ein</li>
            <li>• Korrekte Buchstaben werden grün markiert</li>
            <li>• Bei Vervollständigung aller Wörter erscheint eine Erfolgsmeldung</li>
          </ul>
        </div>
      </div>
    </motion.div>
  );
}

export default CluesList;